import {Component, Input, OnInit, EventEmitter, Output} from '@angular/core'
import {NgbModal} from '@ng-bootstrap/ng-bootstrap'
import {ModalProgramDescMixtaComponent} from '../modal-program-desc-mixta/modal-program-desc-mixta.component'

@Component({
  selector: 'dmmp-search-programs-desc-mixta',
  templateUrl: './search-programs-desc-mixta.component.html'
})
export class SearchProgramsDescMixtaComponent implements OnInit {
  @Input() identifier
  @Input() data
  @Input() filterPrograms
  @Input() categories = []
  @Input() textNoFound = 'No se encontraron resultados'
  @Input() textAll = 'Todos'
  @Input() snies = 'SNIES:'
  @Input() credit = 'CRÉDITOS'
  @Input() duration = 'DURACIÓN ESTIMADA'
  @Output() categoryOut = new EventEmitter()
  @Output() categoriesOut = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  status = true
  notEmptyPost = true
  statusInit = 8
  searchModel

  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
  }

  click(category) {
    this.categoryOut.emit(category)
  }

  sendData(data, identifier) {
    this.status = false
    const modalRef = this.modalService.open(ModalProgramDescMixtaComponent, {size: 'lg'})
    modalRef.componentInstance.data = data
    modalRef.componentInstance.identifier = identifier
    modalRef.componentInstance.snies = this.snies
    modalRef.componentInstance.credit = this.credit
    modalRef.componentInstance.duration = this.duration
    modalRef.componentInstance.categoriesOut.subscribe(($e) => {
      this.categoriesOut.emit($e)
    })
    modalRef.componentInstance.anchorCustom.subscribe(($e) => {
      this.anchorCustom.emit($e)
    })
  }

  onScroll() {
    if (this.notEmptyPost) {
      this.statusInit += 8
    }
  }
}
